import { useCallback, useEffect, useState } from 'react';
import { dotDiametr } from '../initials';
import { produce } from 'immer';

export const useBallPositions = ({
    activeBalls,
    widthCanvas,
}) => {
    const [ballPositions, setBallPositions] = useState([]);

    const changeBallPosition = useCallback((gameID, newPosition) => {
        setBallPositions(prevBallPositions => produce(prevBallPositions, draft => {
            const changedIndex = draft.findIndex(prevBallPosition => prevBallPosition.gameID === gameID);

            if (changedIndex === -1) {
                return;
            }

            draft[changedIndex].x = newPosition.x;
            draft[changedIndex].y = newPosition.y;
        }));
    }, [setBallPositions]);

    useEffect(() => {
        const positions = activeBalls.map(activeBall => ({
            x: widthCanvas / 2 - dotDiametr / 2,
            y: -100,
            gameID: activeBall.gameID,
            winning: activeBall.winning,
            road: activeBall.road,
            // road: '10*11*11*00*11*000*01',
        }));

        setBallPositions(prevPositions => {
            const activeGameIds = activeBalls.map(activeBall => activeBall.gameID);
            const prevPositionWithoutDeleted = prevPositions.filter(prevPosition => activeGameIds.includes(prevPosition.gameID));
            const prevGameIds = prevPositions.map( prevPosition => prevPosition.gameID);
            const newPositions = positions.filter(position => !prevGameIds.includes(position.gameID));
            return [...prevPositionWithoutDeleted, ...newPositions];
        });
    }, [widthCanvas, activeBalls]);

    return [ballPositions, changeBallPosition];
};
